import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { insuranceTypes } from "./quote/types/insuranceOptions";
import { Badge } from "@/components/ui/badge";
import { Star } from "lucide-react";

export const Products = () => {
  return (
    <section className="py-20 bg-gray-50" id="products">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge variant="secondary" className="bg-[#F8F7FF] text-primary text-sm mb-4 flex items-center gap-1 mx-auto w-fit">
            <Star className="h-4 w-4" />
            Comprehensive Solutions
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-4">
            Comprehensive Insurance Solutions
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Protect what matters most with our range of insurance products. Get personalized coverage that fits your needs and budget.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {insuranceTypes.map((type) => (
            <Card key={type.value} className="p-6 hover:shadow-lg transition-shadow">
              <div className="mb-4">
                <type.icon className="w-12 h-12 text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-3">
                {type.label}
              </h3>
              <p className="text-muted-foreground mb-6">
                {getDetailedDescription(type.value)}
              </p>
              <Link to={`/insurance/${type.value}`}>
                <Button variant="outline" className="w-full">
                  Learn More
                </Button>
              </Link>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/quote">
            <Button size="lg" className="text-white">
              Quick Quote
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

const getDetailedDescription = (type: string): string => {
  switch (type) {
    case "auto":
      return "Comprehensive auto insurance coverage to protect you and your vehicle. Get competitive rates on collision, liability, and full coverage options.";
    case "home":
      return "Protect your home and belongings with comprehensive homeowners insurance. Coverage for damage, theft, liability, and more.";
    case "business":
      return "Customized business insurance solutions to protect your company. Coverage includes liability, property, workers comp, and more.";
    case "life":
      return "Secure your family's future with our life insurance policies. Choose from term life, whole life, and universal life options.";
    default:
      return "";
  }
};